import React, { useEffect, useContext, useState, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import videosData from "/data/videosData.json";
import { useLanguage } from "/components/utils/LanguageContext";
import gsap from 'gsap';


export default function Video() {
  const location = useLocation();
  const videoRef = useRef(null);
  const { language } = useLanguage();

  const savedVideoData =
    JSON.parse(localStorage.getItem("currentVideoData")) || {};
  const videoData = location.state?.videoData || savedVideoData;

  const [isVisible, setIsVisible] = useState(false);
  const [isTop, setIsTop] = useState(false);

  useEffect(() => {
    if (location.pathname === "/video" && videoData.path) {
      localStorage.setItem("currentVideoData", JSON.stringify(videoData));
      videoRef.current.volume = 1;
      setTimeout(() => {
        setIsVisible(true);
        setIsTop(true);
      }, 600);
    } else {
      setIsVisible(false);
      fadeOutVideoSound(videoRef.current);
      setTimeout(() => {
        setIsTop(false);
      }, 1000);
    }
  }, [location.pathname, videoData]);

  const fadeOutVideoSound = (videoElement) => {
    gsap.to(videoElement, {
      volume: 0, 
      duration: 1,  
      onComplete: () => {
        videoElement.pause(); 
        videoElement.currentTime = 0;  
      }
    });
  };

  const findNextVideo = () => {
    let allVideos = [];
    Object.values(videosData).forEach((category) => {
      allVideos = allVideos.concat(category);
    });

    const currentIndex = allVideos.findIndex(
      (video) => video.path === videoData.path
    );
    const nextIndex = (currentIndex + 1) % allVideos.length;
    return allVideos[nextIndex];
  };

  const nextVideo = findNextVideo();

  return (
    <>
      <div
        id="video_panel"
        className={`absolute h-full w-full top-0 left-0 right-0 bottom-0 flex-col md:flex-row justify-between flex items-start bg-second shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] transition-all ease-in-out duration-[1000ms] ${
          isVisible ? "opacity-100" : "opacity-0"
        } ${isTop ? "z-10" : "z-0"}`}
      >
        <div className="md:order-1 order-2 flex flex-col justify-between px-6 md:px-10 md:pt-32 pt-6 pb-6 md:pb-10 h-full w-full md:w-1/2 transition-all ease-in-out duration-300">
          <div className="md:flex hidden"></div>
          <div className="flex flex-col gap-5 items-start">
            <div className="flex flex-col gap-1">
              <h2 className="font-['md-avenir'] text-2xl md:text-3xl text-first">
                {language === "EN" ? videoData.enTitle : videoData.frTitle}
              </h2>
              <h3 className="font-['sm-avenir'] text-xs md:text-sm text-first uppercase">
                {language === "EN" ? videoData.enSubtitle : videoData.frSubtitle}
              </h3>
            </div>
            <p className="font-['sm-avenir'] text-sm md:text-base text-first leading-6 md:leading-7">
                {language === "EN" ? videoData.enText : videoData.frText}
            </p>
          </div>
          <div className="relative w-full flex justify-end items-stretch gap-2 mt-4">
            <Link
              to="/fresque"
              className="flex items-center hover:bg-first_alt bg-first transition-all ease-in-out duration-300 uppercase font-['sm-avenir'] fill-second no-underline px-5 md:px-6 py-3.5 md:py-4"
            >
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                xmlns="http://www.w3.org/2000/svg"
                className="fill-second text-base"
              >
                <path d="M8.68907 1.68568L4.56454 5.50492L8.68907 9.32416C9.10364 9.70805 9.10364 10.3282 8.68907 10.7121C8.27449 11.096 7.60478 11.096 7.19021 10.7121L2.31093 6.19396C1.89636 5.81007 1.89636 5.18993 2.31093 4.80604L7.19021 0.287919C7.60478 -0.0959731 8.27449 -0.0959731 8.68907 0.287919C9.09301 0.671812 9.10364 1.30179 8.68907 1.68568Z" />
              </svg>
            </Link>
            <Link
              to="/video"
              state={{ videoData: nextVideo }}
              className="flex justify-center items-start bg-first hover:bg-first_alt transition-all ease-in-out duration-300 text-base uppercase font-['md-avenir'] text-second no-underline px-5 md:px-6 py-3.5 md:py-4"
            >
              Vidéo Suivante
            </Link>
          </div>
        </div>
        <video
          src={`/videos/${videoData.path}`}
          ref={videoRef}
          autoPlay
          playsInline
          disablePictureInPicture
          className="md:order-2 order-1 w-full md:w-1/2 h-1/2 md:h-full bottom-0 right-0 object-cover object-top transition-all ease-in-out duration-300"
        />
      </div>
    </>
  );
}
